import { gql } from '@apollo/client'

const ADD_NEW_INSURANCE_POLICY = gql`
  mutation ADD_NEW_INSURANCE_POLICY(
    $holderName: String!
    $policyNumber: String!
    $coverageType: String
    $relationship: String
    $status: String
    $sponsorNumber: String
    $due: DateTime!
    $inception: DateTime
    $details: String
    $disabled: Boolean
    $insuranceCompany: ID!
    $priceList: ID
  ) {
    addNewInsurancePolicy(
      holderName: $holderName
      policyNumber: $policyNumber
      coverageType: $coverageType
      relationship: $relationship
      status: $status
      sponsorNumber: $sponsorNumber
      due: $due
      inception: $inception
      details: $details
      disabled: $disabled
      insuranceCompany: $insuranceCompany
      priceList: $priceList
    ) {
      id
      holderName
      policyNumber
      coverageType
      relationship
      status
      sponsorNumber
      due
      inception
      details
      disabled
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      insuranceCompany {
        id
        name
      }
      priceList {
        id
        name
      }
    }
  }
`

export default ADD_NEW_INSURANCE_POLICY
